import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContractService } from 'src/app/contract/shared/contract.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-view-notes-dialog',
  templateUrl: './view-notes-dialog.component.html',
  styleUrls: ['./view-notes-dialog.component.scss']
})
export class ViewNotesDialogComponent implements OnInit {
  notes: any[] = [];
  notesLoading: boolean = false;
  userName: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ViewNotesDialogComponent>,
    private contractService: ContractService,
    private toast: ToastrService
  ) {
    // Extract user name from data
    if (data.userInfo) {
      this.userName = `${data.userInfo.firstName || ''} ${data.userInfo.lastName || ''}`.trim();
    } else if (data.userName) {
      this.userName = data.userName;
    }
  }

  async ngOnInit(): Promise<void> {
    await this.loadUserNotes();
  }

  async loadUserNotes(): Promise<void> {
    if (!this.data.contractId || !this.data.userId) {
      return;
    }

    this.notesLoading = true;
    try {
      const allNotes: any = await this.contractService.getNotes(this.data.contractId);
      if (Array.isArray(allNotes)) {
        // Filter notes by user ID (createdBy)
        const userId = this.data.userId.toString();
        this.notes = allNotes
          .filter(note => note.createdBy === userId)
          .sort((a, b) => {
            // Sort by createDate (newest first)
            const dateA = new Date(a.createDate || 0);
            const dateB = new Date(b.createDate || 0);
            return dateB.getTime() - dateA.getTime();
          });
      } else {
        this.notes = [];
      }
    } catch (error) {
      console.error('Error fetching user notes:', error);
      this.toast.error('Failed to load notes. Please try again later.', '');
      this.notes = [];
    } finally {
      this.notesLoading = false;
    }
  }

  formatDateTime(value: string): string {
    if (!value) return 'N/A';
    return moment(value).isValid()
      ? moment(value).format("MMM D, YYYY h:mm A")
      : value;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

